module.exports = __webpack_public_path__ + "static/img/10009 (3).b922216.webp";


//////////////////
// WEBPACK FOOTER
// ./src/assets/10000/10009 (3).webp
// module id = zzVm
// module chunks = 14